export const CRH_SETTINGS_PATH = "/crh/crh-page-settings";
export const CRH_TAXONOMY_INTEREST_GROUPS_PATH = "/crh/contact-taxonomy";
export const CRH_TAXONOMY_CATEGORIES_PATH = "/crh/contact-taxonomy";
export const CRH_TAXONOMY_TOPICS_PATH = "/crh/contact-taxonomy";
export const PCS_TAXONOMY_PATH = "energydrink/qa-taxonomy";
export const PCS_TOPICS_PATH = "energydrink/_shared";
export const FAQ_QUESTIONS_PATH = "questions";
export const PCS_SETTINGS_PATH = "energydrink/_shared";
